import React from 'react';
import '../styles/pages/PolicyPage.css';

function TermsPage() {
  return (
    <div className="policy-page">
      <div className="policy-page__container">
        <header className="policy-page__header">
          <h1 className="policy-page__title">셀프애드 서비스 이용약관</h1>
          <p className="policy-page__date">최종 수정일: 2026년 2월 4일</p>
        </header>

        {/* 목차 */}
        <nav className="policy-page__toc">
          <h2 className="policy-page__toc-title">목차</h2>
          <ul className="policy-page__toc-list">
            <li><a href="#article-1">제1조 (목적)</a></li>
            <li><a href="#article-2">제2조 (용어의 정의)</a></li>
            <li><a href="#article-3">제3조 (약관의 효력 및 변경)</a></li>
            <li><a href="#article-4">제4조 (회원가입)</a></li>
            <li><a href="#article-5">제5조 (회원 탈퇴 및 자격 상실)</a></li>
            <li><a href="#article-6">제6조 (포인트 충전 및 사용)</a></li>
            <li><a href="#article-7">제7조 (프로젝트 계약)</a></li>
            <li><a href="#article-8">제8조 (회사의 의무)</a></li>
            <li><a href="#article-9">제9조 (회원의 의무)</a></li>
            <li><a href="#article-10">제10조 (서비스 제공의 중지)</a></li>
            <li><a href="#article-11">제11조 (면책조항)</a></li>
            <li><a href="#article-12">제12조 (분쟁해결)</a></li>
            <li><a href="#article-13">제13조 (부칙)</a></li>
          </ul>
        </nav>

        {/* 본문 */}
        <div className="policy-page__content">
          <section id="article-1" className="policy-page__section">
            <h2 className="policy-page__section-title">제1조 (목적)</h2>
            <p>본 약관은 (주)카보(이하 "회사")가 운영하는 셀프애드(www.selfad.co.kr, 이하 "플랫폼")에서 제공하는 인플루언서 마케팅 중개 서비스(이하 "서비스")를 이용함에 있어 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
          </section>

          <section id="article-2" className="policy-page__section">
            <h2 className="policy-page__section-title">제2조 (용어의 정의)</h2>
            <ol className="policy-page__list">
              <li>"플랫폼"이란 회사가 제공하는 인플루언서 마케팅 중개 서비스를 말합니다.</li>
              <li>"회원"이란 본 약관에 동의하고 회사와 서비스 이용계약을 체결한 자를 말합니다.</li>
              <li>"광고주"란 인플루언서에게 광고 집행을 의뢰하는 회원을 말합니다.</li>
              <li>"인플루언서"란 광고주의 의뢰를 받아 광고를 집행하는 회원을 말합니다.</li>
              <li>"포인트"란 플랫폼 내에서 사용할 수 있는 선불식 지급수단을 말합니다.</li>
              <li>"프로젝트"란 광고주와 인플루언서 간 체결된 광고 계약을 말합니다.</li>
            </ol>
          </section>

          <section id="article-3" className="policy-page__section">
            <h2 className="policy-page__section-title">제3조 (약관의 효력 및 변경)</h2>
            <ol className="policy-page__list">
              <li>본 약관은 서비스를 이용하고자 하는 모든 회원에게 그 효력이 발생합니다.</li>
              <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.</li>
              <li>약관이 변경되는 경우, 회사는 변경사항을 적용일자 30일 전부터 공지합니다.</li>
              <li>회원이 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다.</li>
            </ol>
          </section>

          <section id="article-4" className="policy-page__section">
            <h2 className="policy-page__section-title">제4조 (회원가입)</h2>
            <ol className="policy-page__list">
              <li>회원가입은 이용자가 본 약관에 동의하고 회사가 정한 가입 양식에 따라 정보를 기입한 후, 회사가 이를 승인함으로써 완료됩니다.</li>
              <li>회원은 반드시 본인의 실명 및 실제 정보를 기입해야 하며, 허위 정보를 기입한 경우 서비스 이용이 제한될 수 있습니다.</li>
              <li>회사는 다음 각 호에 해당하는 경우 회원가입을 거부하거나 사후에 회원자격을 상실시킬 수 있습니다.
                <ul className="policy-page__sublist">
                  <li>가. 타인의 명의를 도용한 경우</li>
                  <li>나. 허위 정보를 기재한 경우</li>
                  <li>다. 관련 법령을 위반하거나 사회질서 및 미풍양속을 저해하는 경우</li>
                  <li>라. 기타 회사가 정한 이용조건을 충족하지 못하는 경우</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-5" className="policy-page__section">
            <h2 className="policy-page__section-title">제5조 (회원 탈퇴 및 자격 상실)</h2>
            <ol className="policy-page__list">
              <li>회원은 언제든지 회사에 탈퇴를 요청할 수 있으며, 회사는 즉시 회원 탈퇴를 처리합니다.</li>
              <li>회원이 다음 각 호의 사유에 해당하는 경우, 회사는 사전 통지 없이 회원자격을 제한 또는 정지시킬 수 있습니다.
                <ul className="policy-page__sublist">
                  <li>가. 타인의 정보를 도용한 경우</li>
                  <li>나. 서비스 운영을 고의로 방해한 경우</li>
                  <li>다. 허위 정보를 기재하거나 부정한 방법으로 포인트를 획득한 경우</li>
                  <li>라. 본 약관을 위반한 경우</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-6" className="policy-page__section">
            <h2 className="policy-page__section-title">제6조 (포인트 충전 및 사용)</h2>
            <ol className="policy-page__list">
              <li>광고주는 플랫폼 내에서 포인트를 충전하여 프로젝트 비용으로 사용할 수 있습니다.</li>
              <li>포인트는 현금 결제를 통해 충전할 수 있으며, 1포인트는 1원의 가치를 가집니다.</li>
              <li>충전된 포인트의 유효기간은 충전일로부터 5년입니다.</li>
              <li>포인트는 타인에게 양도할 수 없습니다.</li>
              <li>광고주의 포인트 환불에 관한 사항은 환불 정책에 따릅니다.</li>
              <li>인플루언서의 포인트 환전은, 3.3%의 사업소득 세금을 포함하여 10%의 플랫폼 수수료를 제외하고 현금으로 환전됩니다.</li>
            </ol>
          </section>

          <section id="article-7" className="policy-page__section">
            <h2 className="policy-page__section-title">제7조 (프로젝트 계약)</h2>
            <ol className="policy-page__list">
              <li>광고주와 인플루언서는 플랫폼을 통해 프로젝트 계약을 체결할 수 있습니다.</li>
              <li>프로젝트를 생성하면 광고주의 포인트에서 프로젝트 비용이 차감됩니다.</li>
              <li>프로젝트가 완료되고 검증이 완료되면, 인플루언서에게 광고비가 지급됩니다.</li>
              <li>계약 불이행 또는 허위 광고의 경우, 회사는 계약을 취소하고 해당 회원에게 불이익을 줄 수 있습니다.</li>
            </ol>
          </section>

          <section id="article-8" className="policy-page__section">
            <h2 className="policy-page__section-title">제8조 (회사의 의무)</h2>
            <ol className="policy-page__list">
              <li>회사는 관련 법령과 본 약관을 준수하며, 계속적이고 안정적으로 서비스를 제공하기 위해 노력합니다.</li>
              <li>회사는 회원의 개인정보 보호를 위해 개인정보처리방침을 수립하고 이를 공시합니다.</li>
              <li>회사는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 판단되는 경우 이를 처리합니다.</li>
            </ol>
          </section>

          <section id="article-9" className="policy-page__section">
            <h2 className="policy-page__section-title">제9조 (회원의 의무)</h2>
            <ol className="policy-page__list">
              <li>회원은 본 약관 및 관련 법령을 준수해야 합니다.</li>
              <li>회원은 다음 행위를 해서는 안 됩니다.
                <ul className="policy-page__sublist">
                  <li>가. 타인의 정보를 도용하는 행위</li>
                  <li>나. 허위 정보를 기재하거나 부정한 방법으로 포인트를 획득하는 행위</li>
                  <li>다. 회사의 서비스 운영을 방해하는 행위</li>
                  <li>라. 타 회원의 개인정보를 무단으로 수집하는 행위</li>
                  <li>마. 관련 법령을 위반하는 행위</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-10" className="policy-page__section">
            <h2 className="policy-page__section-title">제10조 (서비스 제공의 중지)</h2>
            <ol className="policy-page__list">
              <li>회사는 다음 각 호에 해당하는 경우 서비스 제공을 일시적으로 중지할 수 있습니다.
                <ul className="policy-page__sublist">
                  <li>가. 시스템 정기점검, 증설 및 교체를 위해 필요한 경우</li>
                  <li>나. 천재지변 등 불가항력적 사유가 발생한 경우</li>
                  <li>다. 서비스 이용의 폭주 등으로 정상적인 서비스 제공이 불가능한 경우</li>
                </ul>
              </li>
              <li>회사는 서비스 중지 시 사전에 이를 공지하며, 불가피한 경우 사후에 공지할 수 있습니다.</li>
            </ol>
          </section>

          <section id="article-11" className="policy-page__section">
            <h2 className="policy-page__section-title">제11조 (면책조항)</h2>
            <ol className="policy-page__list">
              <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우 책임이 면제됩니다.</li>
              <li>회사는 회원의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.</li>
              <li>회사는 회원 간 또는 회원과 제3자 간에 발생한 분쟁에 대해 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임이 없습니다.</li>
            </ol>
          </section>

          <section id="article-12" className="policy-page__section">
            <h2 className="policy-page__section-title">제12조 (분쟁해결)</h2>
            <ol className="policy-page__list">
              <li>회사와 회원 간 발생한 분쟁에 대해서는 대한민국 법을 적용합니다.</li>
              <li>소송이 필요한 경우, 회사의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.</li>
            </ol>
          </section>

          <section id="article-13" className="policy-page__section">
            <h2 className="policy-page__section-title">제13조 (부칙)</h2>
            <p>본 약관은 2026년 2월 4일부터 시행됩니다.</p>
          </section>
        </div>

        {/* 사업자 정보 */}
        <footer className="policy-page__business-info">
          <h2 className="policy-page__business-info-title">사업자 정보</h2>
          <div className="policy-page__business-info-content">
            <p><strong>상호명:</strong> (주)카보</p>
            <p><strong>사업자등록번호:</strong> 291-86-02840</p>
            <p><strong>대표자:</strong> 이동진</p>
            <p><strong>주소:</strong> 충청남도 계룡시 장안1길 6, 202호</p>
            <p><strong>전화번호:</strong> 044-715-7442</p>
            <p><strong>이메일:</strong> ldjs35@daum.net</p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default TermsPage;
